import { defineStore } from "pinia";
import axios from 'axios'
 

export const useCustomerLoginStore = defineStore("useCustomerLoginStore", () => {

    const router = useRouter();
    const config = useRuntimeConfig();

    const customer = ref(null);
    const dataIndex = ref(null);

    const loggedIn = ref(false);
  
    function initCustomer(data) {
      customer.value = data;
    }
    function initData(data) {
      dataIndex.value = data;
    }
   function initloggedIn(data) {
      loggedIn.value = data;
    }

    async function customerCreate(customer) {
        try {
          const data = await useNuxtApp().$api(`/api/customer/create`,{
            method: 'POST',
            body:{
              ...customer
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
          
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
       async function customerCreateTezge(customer) {
        try {
          const data = await useNuxtApp().$api(`/api/customer/create/tezge`,{
            method: 'POST',
            body:{
              ...customer
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
          
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function updateCustomerPassword(customer) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/reset/password`,{
            method: 'PUT',
            use: 'customer',
            body:{
              ...customer
            }
           })
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      } 
      
      async function updateCustomer(customer) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/update`,{
            method: 'PUT',
            use: 'customer',
            body:{
              ...customer
            }
           })
       
           
            return {
              success: data?.success,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function deleteCustomer() {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/delete`,{
            method: 'DELETE',    
            use: 'customer',  
          })
          
            return {
              success: data?.data,
              data: data?.data,
              errorValidation: {}
            };
          
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function getAuthCustomer() {
        try {
             const data = await useNuxtApp().$apiAuth(`/api/customer/get/auth`,{
                method: 'GET',
                use: 'customer',
             })

            return {
              success: true,
              data: data?.data ?? null,
              errorValidation: {}
            };

        } catch (error) {
  
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function loginCustomer(customer) {
        try {
           
          // await $fetch('/sanctum/csrf-cookie', {
          //     baseURL: config.public.API_BASE_URL_WEB,
          //     credentials: 'include',  
          //   });
        
         
          //  const data = await $fetch('/customer/login', {
          //     baseURL: config.public.API_BASE_URL_WEB,
          //     credentials: 'include', 
          //     headers: {
          //           'X-XSRF-TOKEN': useCookie('XSRF-TOKEN').value  
          //       },
          //       method: 'POST',
          //       body: {
          //        ...customer
          //      }, 
          //   });

          const  { update, reset} = await useSession()

          const data = await useNuxtApp().$api('/api/customer/login',{
            method: 'POST',
            body: {
              ...customer
            }
          })
      
               
          if (!data.success) return

          await reset()

          await update({ "tokenCustomer": data?.data?.token })

          initCustomer(data.data.user);

          initloggedIn(true);
        
            return {
              success: data?.success ?? false,
              data: data?.data,
              errorValidation: {}
            };
           
        } catch (error) {
         
 
          return {
            success: false,
            status: error.response?.status,
            data: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      async function logOutCustomer() {
        const  { session, reset, update } = await useSession()

        const router = useRouter();

        try {
          const data = await useNuxtApp().$apiAuthCustomer(`/api/customer/logout`,{
            method: 'GET'            
         })
         if(!data?.success) return;

         await reset()

         await update({ "tokenCustomer": ''})
         
         initCustomer(null);
         
         initloggedIn(false);
         
         
         router.push('/')
         
            return {
              success: data?.success,
              content: null,
              errorValidation: {}
            };
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            content: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
      // podešavanje naloga: push obaveštenje kada admin odobri bilo koji oglas kupca
      async function getAdApprovalNotify() {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/push/ad-approval`,{
            method: 'GET',
            use: 'customer'
         })
            return {
              success: data?.success,
              data: data?.data
            };

        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null
          };
        }
      }
      async function updateAdApprovalNotify(notify) {
        try {
          const data = await useNuxtApp().$apiAuth(`/api/customer/push/ad-approval`,{
            method: 'PUT',
            use: 'customer',
            body: {
              notify_on_ad_approval: notify
            }
         })
            return {
              success: data?.success,
              data: data?.data
            };

        } catch (error) {

          return {
            success: false,
            status: error.response?.status,
            data: null
          };
        }
      }
      async function getIndexPage() {
        try {
          const data = await useNuxtApp().$api(`/items/index/page`,{
            method: 'GET' 
         })
         initData(data)
           
        } catch (error) {
 
          return {
            success: false,
            status: error.response?.status,
            content: null,
            errorValidation: error?.response?._data?.errors
          };
        }
      }
return {
    customerCreate,
    loginCustomer,
    initCustomer,
    customer,
    loggedIn,
    initloggedIn,
    getAuthCustomer,
    updateCustomer,
    updateCustomerPassword,
    deleteCustomer,
    logOutCustomer,
    getAdApprovalNotify,
    updateAdApprovalNotify,
    getIndexPage,
    dataIndex,
    customerCreateTezge
}
})
